class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 400);

    const facetForm = this.querySelector("form");
    if (facetForm) {
      facetForm.addEventListener("input", (event) => {
        if (
          event.target &&
          event.target.type !== "checkbox" &&
          event.target.type !== "radio" &&
          event.target.tagName !== "SELECT"
        ) {
          this.debouncedOnSubmit(event);
        }
      });

      facetForm.addEventListener("change", (event) => {
        if (
          event.target &&
          (event.target.type === "checkbox" ||
            event.target.type === "radio" ||
            event.target.tagName === "SELECT")
        ) {
          if (typeof addFacetSpinner === "function") addFacetSpinner(event.target);
          this.onSubmitHandler(event);
        }
      });
    }

    const facetWrapper = this.querySelector(".FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));

    if (event && event.target) {
      const label = event.target.closest(".facet-checkbox") || event.target.closest("label") || event.target.closest(".facets__item");
      if (label) label.classList.add("is-loading");
    }

    const gridContainer = document.getElementById("ProductGridContainer");
    if (gridContainer) {
      const collection = gridContainer.querySelector(".collection");
      if (collection) collection.classList.add("loading");
    }
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static currentFetchController = null;

  static renderSectionFromFetch(url, event) {
    if (FacetFiltersForm.currentFetchController) {
      FacetFiltersForm.currentFetchController.abort();
    }
    FacetFiltersForm.currentFetchController = new AbortController();
    const { signal } = FacetFiltersForm.currentFetchController;

    fetch(url, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        console.error(error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const countElement = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount");
    const count = countElement ? countElement.innerHTML : "";
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    if (container) {
      container.innerHTML = count;
      container.classList.remove("loading");
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));

    document.querySelectorAll(".facet-checkbox.is-loading, .facets__item.is-loading, label.is-loading").forEach((element) => {
      element.classList.remove("is-loading");
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter,#FacetFiltersForm_mega_menu .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter,#FacetFiltersForm_mega_menu .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so smoothly update without destroying details structure
      if (currentElement) {
        if (currentElement.tagName === "DETAILS") {
          const currentSummary = currentElement.querySelector("summary");
          const newSummary = elementToRender.querySelector("summary");
          if (currentSummary && newSummary) {
            currentSummary.innerHTML = newSummary.innerHTML;
          }
          const currentDisplay = currentElement.querySelector(
            ".facets__display-vertical, .facets__display, .parent-display, .facets-wrap"
          );
          const newDisplay = elementToRender.querySelector(
            ".facets__display-vertical, .facets__display, .parent-display, .facets-wrap"
          );
          if (currentDisplay && newDisplay) {
            currentDisplay.innerHTML = newDisplay.innerHTML;
          } else {
            currentElement.innerHTML = elementToRender.innerHTML;
          }
        } else {
          currentElement.innerHTML = elementToRender.innerHTML;
        }
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const isCheckboxOrRadio =
          event.target.type === "checkbox" || event.target.type === "radio";
        const isTextInput = event.target.getAttribute("type") === "text";

        // Only restore focus if user is not clicking checkboxes/radios, to prevent viewport scroll jumps
        if (!isCheckboxOrRadio && !isTextInput) {
          const newFacetDetailsElement =
            document.getElementById(closestJSFilterID);
          const newElementSelector = newFacetDetailsElement.classList.contains(
            "mobile-facets__details"
          )
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate =
            newFacetDetailsElement.querySelector(newElementSelector);
          if (newElementToActivate) newElementToActivate.focus({ preventScroll: true });
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const targetEl = document.querySelector(selector);
      if (targetEl) {
        targetEl.innerHTML = activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const targetEl = document.querySelector(selector);
      if (targetEl) {
        targetEl.innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    const mobileMenuDrawer = document
      .getElementById("FacetFiltersFormMobile")
      ?.closest("menu-drawer");
    if (
      mobileMenuDrawer &&
      typeof mobileMenuDrawer.bindEvents === "function" &&
      !mobileMenuDrawer.classList.contains("mega-filter")
    ) {
      mobileMenuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.innerHTML = sourceSummary.innerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.innerHTML = sourceHeaderElement.innerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.innerHTML = sourceWrapElement.innerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf("?") + 1
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
    this.noUifilter();
  }
  connectedCallback() {
    this.noUifilter();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.noUifilter();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  noUifilter() {
    const sliderRange = this.querySelector(".slider-range");
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    let minValue = parseFloat(minInput.value);
    let maxValue = parseFloat(maxInput.value);

    if (isNaN(minValue) || minValue < 0) {
      minValue = 0;
    }
    if (isNaN(maxValue) || maxValue < 0) {
      maxValue = parseFloat(maxInput.getAttribute("max")) || 0; // fallback to max attribute if invalid
    }

    if (!sliderRange.classList.contains("noUi-target")) {
      noUiSlider.create(sliderRange, {
        start: [minValue, maxValue],
        connect: true,
        step: 1,
        range: {
          min: 0,
          max: parseFloat(maxInput.getAttribute("max")) || 100, // default max value
        },
      });

      sliderRange.noUiSlider.on("change", (values, handle) => {
        if (handle === 0) {
          minInput.value = values[handle];
        }
        if (handle === 1) {
          maxInput.value = values[handle];
        }

        // Trigger input event on form
        const event = new CustomEvent("input");
        const form =
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form");
        form.querySelector("form").dispatchEvent(event);
      });

      // Update slider values based on input changes
      minInput.addEventListener("change", () => {
        const minValue = parseFloat(minInput.value);
        if (!isNaN(minValue)) {
          sliderRange.noUiSlider.set([minValue, null]);
        }
      });

      maxInput.addEventListener("change", () => {
        const maxValue = parseFloat(maxInput.value);
        if (!isNaN(maxValue)) {
          sliderRange.noUiSlider.set([null, maxValue]);
        }
      });
    }
  }
}
customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
document.addEventListener("DOMContentLoaded", function () {
  const facetsDisclosure = document.querySelector(".mega-filter");

  // Function to toggle the filter popup
  function toggleFilter(isOpen) {
    const disclosure = facetsDisclosure || document.querySelector(".mega-filter");
    if (disclosure) {
      disclosure.classList.toggle("active", isOpen);
      document.body.classList.toggle("no-scroll", isOpen);

      if (isOpen) {
        setTimeout(() => {
          disclosure.classList.add("overflow-auto");
        }, 500); // Delay for overflow-auto
      } else {
        disclosure.classList.remove("overflow-auto");
      }
    }
  }

  // Event delegation for dynamically added buttons
  document.body.addEventListener("click", function (event) {
    // Handle open button click
    if (event.target.closest(".filter-popup-open-btn")) {
      toggleFilter(true);
    }

    // Handle close button click
    if (event.target.closest(".filter-popup-close-btn") || event.target.closest(".mobile-facets__footer .button--primary")) {
      toggleFilter(false);
    }

    // Handle overlay click to close the popup
    const disclosure = facetsDisclosure || document.querySelector(".mega-filter");
    if (event.target === disclosure) {
      toggleFilter(false);
    }
  });
});

// Global instant spinner handler for facet checkboxes
function addFacetSpinner(target) {
  if (!target) return;
  const label = target.closest(".facet-checkbox") || target.closest("label") || target.closest(".facets__item") || target.closest(".mobile-facets__item");
  if (label) {
    label.classList.add("is-loading");
    const textLabel = label.querySelector(".facet-checkbox__text-label");
    if (textLabel) {
      textLabel.classList.add("is-loading");
      if (!textLabel.querySelector(".facet-spinner")) {
        const spinner = document.createElement("span");
        spinner.className = "facet-spinner";
        textLabel.appendChild(spinner);
      }
    }
  }
}

document.addEventListener("click", function (event) {
  const target = event.target;
  if (target && (target.closest(".facet-checkbox") || target.closest("label.facets__label") || target.closest(".mobile-facets__item") || target.closest(".facets__item"))) {
    addFacetSpinner(target);
  }
});



